module.exports = __webpack_public_path__ + "img/accelerator-1.b54b2ca2.png";